import { INSTANCES } from './overlay-instances';

export function invokeDialog(openOverlay, modalProps, facets = []) {
    return new Promise((resolve, reject) => {
        const props = {
            onAccept: resolve,
            onDecline: reject,
            ...modalProps,
        };

        openOverlay({
            id: INSTANCES.MODAL,
            transition: 'trs-simple-fade',
            facets,
            component: 'overlay-recipe-dialog',
            props,
        });
    });
}
